<template>
  <div v-if="value">
    <h3 v-if="title" class="text-center">{{ title }}</h3>
    <h4 class="text-center" v-if="value.items && value.items.length == 0">{{ emptyDescription }}</h4>
    <template v-for="(item, index) in value.items">
      <PartSlider
        :key="index"
        :index="index"
        v-model="value.items[index]"
        :part1="parts[0]"
        :part2="parts[1]"
        :protocol="protocol"
        :inputLabel="inputLabel"
        :inputHint="inputHint"
        :icon="icon"
        @delete-slider="deletePartSlider"
      />
    </template>
    <div class="text-center">
      <v-btn color="success" large @click="addPartSlider" class="mb-4 mt-2">{{ addButton }} </v-btn>
    </div>
  </div>
</template>

<script>
import PartSlider from "./PartSlider";
export default {
  props: ["value", "protocol", "title", "inputLabel", "inputHint", "emptyDescription", "icon", "addButton"],
  components: { PartSlider },
  data() {
    return {};
  },
  computed: {
    parts: {
      get() {
        if (this.protocol.saved_values.participants.tenants) {
          if (this.protocol.saved_values.participants.tenants.length == 2) {
            return this.protocol.saved_values.participants.tenants;
          }
        }
        return [{firstname: "Mangler", lastname: "deltaker"}, {firstname: "Mangler", lastname: "deltaker"}];
      }
    }
  },
  methods: {
    addPartSlider() {
      this.value.items.push({"title": "", "sliderValue": 50})
    },
    deletePartSlider(i) {
      this.value.items.splice(i, 1);
    }
  }
};
</script>